import { render } from "./InputDialog.vue?vue&type=template&id=b42671a0"
import script from "./InputDialog.vue?vue&type=script&lang=js"
export * from "./InputDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__